import React from 'react'
import { Breakpoint } from 'react-socks'

export default ({ children }) => (
  <Breakpoint maxWidthBodyLow up>
    {children}
  </Breakpoint>
)
